import apiClient from './axiosInstanceStock'

export const deleteCartItem = async (id) => {
    return await apiClient.delete(`/v1/cartStocks/delete/${id}`);
  };
  
